"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePasswordWidget = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var update_password_1 = require("../../../api/calls/user/update_password");
var main_1 = require("../../../reducers/slices/main");
var user_1 = require("../../../reducers/slices/user");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var ProfilePasswordWidget = function (props) {
    var _a = props;
    var cookie = new universal_cookie_1.default();
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _b = (0, react_1.useState)(""), currentPassword = _b[0], setCurrentPassword = _b[1];
    var _c = (0, react_1.useState)(""), newPassword = _c[0], setNewPassword = _c[1];
    var _d = (0, react_1.useState)(""), confirmPassword = _d[0], setConfirmPassword = _d[1];
    var _e = (0, react_1.useState)(false), isEditing = _e[0], setIsEditing = _e[1];
    var _f = (0, react_1.useState)(""), currentPasswordMessage = _f[0], setCurrentPasswordMessage = _f[1];
    var _g = (0, react_1.useState)(""), newPasswordMessage = _g[0], setNewPasswordMessage = _g[1];
    var _h = (0, react_1.useState)(""), confirmPasswordMessage = _h[0], setConfirmPasswordMessage = _h[1];
    var _j = (0, react_1.useState)(false), isSaving = _j[0], setIsSaving = _j[1];
    (0, react_1.useEffect)(function () {
        //
    }, []);
    var clearMessages = function () {
        setCurrentPasswordMessage("");
        setNewPasswordMessage("");
        setConfirmPasswordMessage("");
    };
    var validatePassword = function () {
        var messageCount = 0;
        clearMessages();
        if (!currentPassword) {
            messageCount++;
            setCurrentPasswordMessage("Current password is required.");
        }
        if (!newPassword) {
            messageCount++;
            setNewPasswordMessage("New password is required.");
        }
        if (!confirmPassword) {
            messageCount++;
            setConfirmPasswordMessage("Confirm password is required.");
        }
        if (newPassword != confirmPassword) {
            messageCount++;
            setConfirmPasswordMessage("Confirm password does not match new password.");
        }
        return messageCount ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4 p-4 border border-borders rounded-lg" },
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "flex-1" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Password", size: "large", textColor: "text-black" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-4" },
                react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: isEditing ? pro_solid_svg_icons_1.faSave : pro_solid_svg_icons_1.faPen, backgroundColor: isEditing ? "bg-success" : "bg-primary", iconColor: "text-white", size: "xsmall", loading: isSaving, onClick: function () {
                        if (isEditing) {
                            if (validatePassword()) {
                                // dispatch(
                                //   update_password_thunk({
                                //     currentPassword: currentPassword,
                                //     newPassword: newPassword,
                                //   })
                                // );
                                setIsSaving(true);
                                (0, update_password_1.update_password)({
                                    current_password: currentPassword,
                                    new_password: newPassword,
                                }).then(function (response) {
                                    setIsSaving(false);
                                    if (response.success) {
                                        setIsEditing(false);
                                        // Update the state.
                                        dispatch((0, user_1.setUser)(response.content));
                                        // If cookie was saved before, update it.
                                        if (cookie.get("user_state")) {
                                            cookie.set("user_state", response.content, {
                                                sameSite: true,
                                            });
                                        }
                                    }
                                    else {
                                        dispatch((0, main_1.setMainModal)({ title: "Something went wrong!", messages: [response.message] }));
                                    }
                                });
                            }
                        }
                        else {
                            setIsEditing(true);
                        }
                    } }),
                isEditing && (react_1.default.createElement(doshx_controls_web_1.IconButtonControl, { icon: pro_solid_svg_icons_1.faClose, backgroundColor: "bg-primary", iconColor: "text-white", size: "xsmall", onClick: function () {
                        clearMessages();
                        setIsEditing(false);
                    } })))),
        react_1.default.createElement("div", { className: "flex flex-row gap-4" },
            react_1.default.createElement("div", { className: "flex-1 flex flex-col gap-4" },
                isEditing && (react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Current Password", value: isEditing ? currentPassword : "*******", disabled: !isEditing, size: "small", type: "password", textColor: "text-black", labelColor: "text-black", borderColor: "border-borders", errorText: currentPasswordMessage, onChange: function (v) { return setCurrentPassword(v); } })),
                react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: isEditing ? "New Password" : "Password", value: isEditing ? newPassword : "*******", disabled: !isEditing, size: "small", type: "password", textColor: isEditing ? "text-black" : "text-disabled", labelColor: isEditing ? "text-black" : "text-disabled", borderColor: isEditing ? "border-borders" : "border-disabled", errorText: newPasswordMessage, onChange: function (v) { return setNewPassword(v); } }),
                isEditing && (react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Confirm Password", value: confirmPassword, disabled: !isEditing, size: "small", type: "password", textColor: "text-black", labelColor: "text-black", borderColor: "border-borders", errorText: confirmPasswordMessage, onChange: function (v) { return setConfirmPassword(v); } }))))));
};
exports.ProfilePasswordWidget = ProfilePasswordWidget;
